import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { ProfileCard } from '@/components/common/ProfileCard';
import { ChangePasswordDialog } from './ChangePasswordDialog';

const P = UI_STRINGS.PROFILE;

/**
 * Password card (client-approved Option D): the masked password with "Change
 * Password" in the card header. Opens `ChangePasswordDialog`, which saves via
 * `PATCH /me/password`.
 */
export function PasswordCard() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const action = (
    <Button variant="outline-md" onClick={() => setIsDialogOpen(true)}>
      {P.CHANGE_PASSWORD}
    </Button>
  );

  return (
    <ProfileCard title={P.SECTION_PASSWORD} action={action}>
      <p className="text-[1.25rem] tracking-[2px] text-subtext">
        {P.PASSWORD_MASKED}
      </p>
      <ChangePasswordDialog open={isDialogOpen} onOpenChange={setIsDialogOpen} />
    </ProfileCard>
  );
}
